import React from "react";
import { motion } from "framer-motion";
type ItemProps = {
  title: string;
  company?: string;
  description: string;
  date: string;
  icon: React.ReactNode;
  location: string;
};
type Props = {
  data: [ItemProps] | any;
};

const fadeInAnimationVariants = {
  initial: {
    opacity: 0,
    y: 100,
  },
  animate: (index: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: 0.05 * index,
    },
  }),
};

const Timeline = ({ data }: Props) => {
  return (
    <section className="relative flex flex-col justify-start bg-transparent overflow-hidden">
      <div className="w-full px-4 md:px-6 py-4">
        <div className="flex flex-col justify-center divide-y divide-slate-200 ">
          <div className="w-full">
            <div className="space-y-8 relative before:absolute before:inset-0 before:ml-5 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-transparent before:via-slate-300 before:to-transparent">
              {/* Start */}
              {(data || [])?.map((item: any, index: number) => (
                <motion.div
                  className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active"
                  variants={fadeInAnimationVariants}
                  initial="initial"
                  whileInView="animate"
                  viewport={{
                    once: true,
                  }}
                  custom={index}
                  key={index}
                >
                  <div className="flex items-center justify-center w-10 h-10 rounded-full border border-slate-700 bg-slate-700 group-[.is-active]:bg-slate-700 text-white/80 shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2">
                    {item.icon}
                  </div>

                  <div className="w-[calc(100%-4rem)] text-sm md:w-[calc(50%-2.5rem)]  px-5 py-3 bg-white/10 text-white/80 borderBlack rounded-xl shadow">
                    <div className="flex items-center justify-between space-x-2">
                      <div className="md:text-sm text-[12px] font-medium">{item.location}</div>
                      <time className="md:text-xs text-[10px] font-medium ">{item.date}</time>
                    </div>
                    <div className="font-bold text-lg mt-8">{item.company}</div>
                    <div className="font-semibold mb-7">{item.title}</div>
                    <div className="text-sm text-start">{item.description}</div>
                  </div>
                </motion.div>
              ))}

              {/* End */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Timeline;
